import { InjectionToken } from '@angular/core';
import { CommonsUserUtilsService } from 'ib-web-commons/app/core/utils/ib-commons-user-utils.service';
import { upgradeAJSServiceProvider } from 'ib-web-commons/utils'; 
export const AJSGiftCardsCommonsUserUtilsService = new InjectionToken('CommonsUserUtilsService');
export const AJSGiftCardsCommonsUserUtilsServiceProvider = upgradeAJSServiceProvider('CommonsUserUtilsService', AJSGiftCardsCommonsUserUtilsService);
export interface GiftCardsCommonsUserUtilsServiceType extends CommonsUserUtilsService {
    getUserRole()
    isIbPlus()
}
